angular.module('aprima-legacy-common')
    .factory('NoteTypeRepository',
        ['_', 'SystemGuid', function (_, SystemGuid) {
            'use strict';

            // TODO: before releasing, comment out those that we don't actually support.
            /*jshint camelcase: false */
            var supportedTabs = [
                '3e4888e6-a0be-4e5b-bdbf-3da7d4f71375', //Assessments
                SystemGuid.UIControl_Note_CC,
                SystemGuid.UIControl_Note_CCHPI,
                'ffbb556f-ab4e-478f-a2d7-b4b863a344e9', //CDS
                SystemGuid.UIControl_Note_Confidential,
                '2c513cab-0d52-4e06-b64f-dc6391e464b7', //CPP
                SystemGuid.UIControl_Note_DX,
                SystemGuid.UIControl_Note_DXDSM,
                SystemGuid.UIControl_Note_GeneralNote,
                '8b40d89b-3511-42a4-b07b-decadc72647e', //General Note CC
                SystemGuid.UIControl_Note_HPI,
                SystemGuid.UIControl_Note_HX,
                '38080e33-7a49-4e4d-9d5c-ff87319d8307', //Observation
                SystemGuid.UIControl_Note_PE,
                SystemGuid.UIControl_Note_Plan,
                SystemGuid.UIControl_Note_Results,
                SystemGuid.UIControl_Note_ROS,
                SystemGuid.UIControl_Note_ROSPE,
                SystemGuid.UIControl_Note_RX,
                '871c47ed-372f-4c89-a4b8-c753951ca93e', //Single CPP
                SystemGuid.UIControl_Note_SO,
                SystemGuid.UIControl_Note_SP,
                SystemGuid.UIControl_Note_VisitText,
                SystemGuid.UIControl_Note_Vitals,
            ];

            var supportedSliders = [
                '2f35a3bb-0778-4cd6-a178-7734e7b4836e', //Attachments
                '4836176d-e412-47e9-ab6b-b549515c8007', //Calendar
                'bf9d1d68-cdcc-48f0-8080-1815212914fb', //CCM/CPO
                '41e171a8-667a-4ade-aba4-dc7ce21c30d7', //Clinical Decision Support
                '87d90295-1cbf-41cd-8582-fad6e0a7a4b9', //Dictation
                '142937f8-4c55-4c15-9677-f1a2105a019e', //Education Forms
                '5b8fa2e2-31fa-40aa-bbf6-9d969ae5cc71', //Follow-up
                '41e171a8-667a-4ade-aba4-dc7ce21c30d7', //Health Maintenance
                '48606f65-ddf6-4f83-afaf-7dfb842d13d6', //Numeric Keypad
                '881ee22a-9193-45b3-85f5-818e4bd6ece9', //Rx Summary
                'b9d820ab-b216-47bf-af2d-b7ebfb79a137', //Text Note
                '14266173-8cfc-4b4e-8fa6-8f95ea61e03d', //Visit Information
            ];

            function isNoteTabsSupported(note) {
                if(_.isNil(note)) { return false; }
                var noteTabs = _.map(note.Tabs, 'TabSliderUid');

                var matchedTabs = _.intersection(noteTabs, supportedTabs);
                return matchedTabs.length === noteTabs.length;
            }

            function isNoteSlidersSupported(note) {
                if(_.isNil(note)) { return false; }
                var noteSliders = _.map(note.Sliders, 'TabSliderUid');

                var matchedSliders = _.intersection(noteSliders, supportedSliders);
                return matchedSliders.length === noteSliders.length;
            }

            function isNoteTypeSupported(note) {
                if(_.isNil(note)) { return false; }
                return isNoteTabsSupported(note) && isNoteSlidersSupported(note);
            }

            return {
                isNoteTypeSupported: isNoteTypeSupported,
                isNoteTabsSupported: isNoteTabsSupported,
                isNoteSlidersSupported: isNoteSlidersSupported,
            };
        }]);
